module.exports = __webpack_public_path__ + "img/detailed_plan.14e90d47.png";